import { useEffect, useState } from "react";
import axios from "axios";
import { getUser } from "@/lib/user";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Anti-cache : dès qu'un abonnement s'active, le navigateur doit relâcher l'image floutée. */
export const versionMedia = () => Math.floor(Date.now() / 60000);

const VIDE = {
  connecte: false, admin: false, apercu_actif: false, secondes_restantes: 0,
  duree_minutes: 5, acces: {}, numeros_debloques: false,
};

/**
 * État d'accès visuel du membre : 5 minutes de photos nettes offertes à la connexion
 * (une fois par 24 h), puis floutage tant qu'aucun abonnement ne couvre la rubrique.
 */
export const useApercu = () => {
  const [etat, setEtat] = useState(VIDE);

  const charger = async () => {
    const user = getUser();
    if (!user) return setEtat(VIDE);
    try {
      const r = await axios.get(`${API}/acces/apercu`, { params: { profile_id: user.id } });
      setEtat(r.data);
    } catch {
      setEtat(VIDE);
    }
  };

  useEffect(() => {
    charger();
    const rafraichir = setInterval(charger, 30000);
    return () => clearInterval(rafraichir);
  }, []);

  // compte à rebours local entre deux rafraîchissements serveur
  useEffect(() => {
    if (!etat.apercu_actif || etat.admin || etat.secondes_restantes <= 0) return;
    const tic = setInterval(() => {
      setEtat((e) => {
        const restantes = e.secondes_restantes - 1;
        return { ...e, secondes_restantes: Math.max(restantes, 0), apercu_actif: restantes > 0 };
      });
    }, 1000);
    return () => clearInterval(tic);
  }, [etat.apercu_actif, etat.admin, etat.secondes_restantes > 0]);

  /**
   * Décision du propriétaire (03/07/2026) : plus AUCUN floutage de photo sur le site,
   * pour personne. Seuls les NUMÉROS de téléphone restent réservés aux abonnés de la
   * rubrique concernée (voir `acces` / `numeros_debloques`).
   */
  const photosNettes = () => true;

  return { ...etat, photosNettes, recharger: charger };
};

export const formatChrono = (secondes) => {
  const m = Math.floor(Math.max(secondes, 0) / 60);
  const s = Math.max(secondes, 0) % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

/**
 * URL d'un média de l'API avec l'identité du visiteur : INDISPENSABLE, sinon le serveur
 * renvoie toujours la version floutée (même à un abonné qui vient de payer).
 */
export const urlMedia = (url) => {
  if (!url?.startsWith("/api")) return url;
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem("fodindin_user"));
    } catch {
      return null;
    }
  })();
  const separateur = url.includes("?") ? "&" : "?";
  return `${process.env.REACT_APP_BACKEND_URL}${url}${separateur}v=${versionMedia()}${
    user ? `&viewer_id=${user.id}` : ""
  }`;
};
